import { api } from 'src/pages/APIs';
import AbstractApiService from 'src/services/abstractApiService';

// TypeScript interfaces for API request/response
export interface ClearFlowUntilRestartRequest {
  confirm: true;
}

export interface FlowStep {
  name: string;
  id: string;
  success: boolean;
  action: string;
  module?: string;
  time?: string;
  waiting_time?: string;
  celery_task_id?: string;
}

export interface ClearFlowUntilRestartResponse {
  success: boolean;
  message: string;
  cleared_steps_count: number;
  remaining_steps: FlowStep[];
}

export interface ClearFlowErrorResponse {
  success: false;
  error: string;
  message: string;
}

// Parameters for organization flow data
export interface FlowDataOrgParams {
  orgId: string;
  start_date: string;
  end_date: string;
}

export default class DocumentFlowDataService extends AbstractApiService {
  public constructor() {
    super({});
  }

  public async getData(docID: string): Promise<any> {
    return this.get(api.get_flow_data + docID);
  }

  public async getData_org(params: FlowDataOrgParams): Promise<any> {
    try {
      const url = `${api.get_flow_data_org}?org_id=${params.orgId}&start_date=${params.start_date}&end_date=${params.end_date}`;
      return await this.get(url);
    } catch (error: any) {
      if (error.response?.data) {
        throw error.response.data;
      }
      throw error;
    }
  }

  public async getSystemAverage(start_date: string, end_date: string, doc_types?: string[]): Promise<any> {
    try {
      let url = `${api.get_flow_data_system_avg}?start_date=${start_date}&end_date=${end_date}`;
      if (doc_types && doc_types.length > 0) {
        url += `&doc_types=${doc_types.join(',')}`;
      }
      const response = await this.get(url);
      return response;
    } catch (error: any) {
      if (error.response?.data) {
        throw error.response.data;
      }
      throw error;
    }
  }

  public async clearUntilRestart(
    docID: string,
  ): Promise<ClearFlowUntilRestartResponse> {
    const requestBody: ClearFlowUntilRestartRequest = { confirm: true };

    try {
      const response = await this.delete(
        api.clear_flow_until_restart + docID,
        requestBody,
      );
      return response as ClearFlowUntilRestartResponse;
    } catch (error: any) {
      // Re-throw with proper typing for error handling
      if (error.response?.data) {
        throw error.response.data as ClearFlowErrorResponse;
      }
      throw error;
    }
  }
}
